import es from '@/locales/es.json';
import fr from '@/locales/fr.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'es', label: 'ES', flag: '🇪🇸' },
  { code: 'fr', label: 'FR', flag: '🇫🇷' },
] as const;

export type Language = 'es' | 'fr';

export const DEFAULT_LANGUAGE: Language = 'es';

const translations: Record<Language, typeof es> = { es, fr };

export function getTranslations(language: Language): typeof es {
  return translations[language] ?? translations[DEFAULT_LANGUAGE];
}
